import React from 'react';
import { useSnackbar } from '../../contexts/SnackbarContext';
import Snackbar from './Snackbar';

const SnackbarContainer = () => {
    const { snackbars, dismissSnackbar } = useSnackbar();

    if (snackbars.length === 0) return null;

    return (
        <div className="fixed bottom-4 right-4 z-50 flex flex-col items-end">
            {snackbars.map((snackbar) => (
                <Snackbar
                    key={snackbar.id}
                    id={snackbar.id}
                    message={snackbar.message}
                    type={snackbar.type}
                    onDismiss={dismissSnackbar}
                />
            ))}
        </div>
    );
};

export default SnackbarContainer; 